import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["BaseInput"], {
    errorMessage: $setup.errorMessage,
    meta: $setup.meta,
    name: $props.name,
    label: $props.label,
    labelPosition: $props.labelPosition
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["relative z-[2] w-full", { 'mt-2': !!$props.label }])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($props.type !== 'textarea' ? 'input' : 'textarea'), {
          class: _normalizeClass(["appearance-none outline-none border-0 focus:shadow-purple-500 shadow-none block w-full rounded-[8px] bg-[#efefef] dark:bg-white h-[51px] p-[16px] text-[14px] leading-[19px] tracking-[0px] font-roboto placeholder:text-opacity-50 text-gray-800", {
                    'opacity-50 bg-gray-100 pointer-events-none': $props.locked,
                    'border-red-300 text-red-900 focus:outline-none focus:ring-red-500 focus:border-red-500': $setup.errorMessage && $setup.meta.touched,
                    'bg-none border-white': $props.type !== 'textarea',
                    'resize-none min-h-[111px] bg-white': $props.type === 'textarea',
                }]),
          name: $props.name,
          id: $props.name,
          type: $props.type,
          value: $setup.inputValue,
          autocomplete: $props.autocomplete,
          placeholder: $props.placeholder,
          onInput: $setup.customHandleChange,
          onBlur: $setup.handleBlur
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["class", "name", "id", "type", "value", "autocomplete", "placeholder", "onBlur"])),
        ($setup.errorMessage && $setup.meta.touched)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode($setup["ExclamationCircleIcon"], {
                class: "w-5 h-5 text-red-500",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["errorMessage", "meta", "name", "label", "labelPosition"]))
}